import SectionHeading from './SectionHeading';
import { useInView } from '../hooks/useInView';
import { skills } from '../data/resume';

export default function Skills() {
  const [ref, isVisible] = useInView();

  return (
    <section id="skills" className="section" ref={ref}>
      <div className={`reveal ${isVisible ? 'reveal--visible' : ''}`}>
        <SectionHeading number="03" title="Skills" />

        <div className="skills-grid">
          <div className="skills-group">
            <h3 className="skills-label">Languages</h3>
            <div className="skills-chips">
              {skills.languages.map((skill) => (
                <span key={skill} className="skill-chip">{skill}</span>
              ))}
            </div>
          </div>

          <div className="skills-group skills-group--wide">
            <h3 className="skills-label">Technologies & Tools</h3>
            <div className="skills-chips">
              {skills.technologies.map((skill) => (
                <span key={skill} className="skill-chip skill-chip--outline">{skill}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
